import { useState } from 'react';
import { Button } from '@stitch-fix/mode-react';
import ProductCard from '@stitch-fix/mode-react/ProductCard';
import { TopItemFragment } from '../../../utils/hooks/getTopItems';
import { TopItemsOverflowMenu } from './TopItemsOverflowMenu';
import { OutfitsModal } from '../../OutfitsModal/OutfitsModal';
type TopItemsProductCardProps = {
  topItem: TopItemFragment;
};

/**
 * Formats the Product Card's PDP URL.
 * Sets the `source` and `query_id` query params for tracking events in the PDP.
 */
const getPDPUrl = (variantUrl: string) => {
  const pdpQueryParams = 'source=top_items';
  return `${variantUrl}&${pdpQueryParams}`;
};

/**
 * Top Item Product Card component renders the product card, and variouse
 * interactions like the overflow menu and action footer.
 */
export const TopItemsProductCard = ({
  topItem
}: TopItemsProductCardProps) => {
  const [outfitsModalOpened, setOutfitsModalOpened] = useState<boolean>(false);
  const handleOutfitsModalClose = () => {
    setOutfitsModalOpened(false);
  };
  return <ProductCard name="" heroAction={<TopItemsOverflowMenu keptItem={topItem.keptItem} />} sku={topItem.shopProductVariant.sku} key={topItem.skuId} heroStageAspectRatio="4:5" href={getPDPUrl(topItem.shopProductVariant.url)} cardSize="small" heroMedia={topItem.shopProductVariant.image ? {
    alt: topItem.shopProductVariant.image.altText,
    baseUrl: topItem.shopProductVariant.image.baseUrl || '',
    mediaPath: topItem.shopProductVariant.image.mediaPath || '',
    sizes: {
      sm: 320
    }
  } : undefined} stickerLabel={topItem.keptItem.returnInProgress ? {
    text: 'Return in progress',
    variant: 'navy'
  } : undefined} actionFooter={topItem.shopProductVariant.mayHaveOutfits && <>
            <Button onClick={() => setOutfitsModalOpened(true)} variant="text" width="fill">
              View Outfits
            </Button>
            <OutfitsModal skuId={topItem.skuId} open={outfitsModalOpened} handleModalClose={handleOutfitsModalClose} />
          </>} />;
};